import $ from 'jquery';

var Tab = {
    init: function() {
        this.setEvents();
    },

    setEvents: function() {
        $(document).on('click', '.tab-menu > a', this.menuClick.bind(this));
    },

    menuClick: function(e) {
        e.preventDefault();

        var menu = $(e.currentTarget);

        if (menu.hasClass('active')) {
            return;
        }

        this.select(menu.parents('.tab:first'), menu.index());
    },

    select: function(container, menu_index) {
        container.find('> .tab-menu > a.active').removeClass('active');
        container.find('> .tab-content > div.active').removeClass('active');

        container.find('> .tab-menu > a').eq(menu_index).addClass('active');
        container.find('> .tab-content > div').eq(menu_index).addClass('active');
    }
};

export default Tab;